import {setProgressBar} from './setProgressBar';
import {onlineOrderFlowInit} from "./onlineOrderFlowInit";
export function progressBarDisplay (){ 
    let isLeadOnly = window.objOSGlobal.requestBodyValues.IsLeadOnly
     $('.modal-header-two').css('display', "flex");
     $('.progressbar, .progress').show();
     onlineOrderFlowInit();
     if(isLeadOnly){
        $('.progressbar a[data-step="calendar-screen"]').parent().hide();
        $('.progressbar a[data-step="about-home-screen"], .progressbar a[data-step="estimate-screen"]').parent().hide();
        $('.progressbar a[data-step="service-details-screen"]').parent().show();  
        $('.progressbar').addClass('lead-flow');
        $('.progressbar a[data-step="contact-information-screen"]').parent().addClass('isLeadContact');
        $('.progressbar li').css('width', 'calc(100%/4)');
        $('.progressbar li:nth-child(4) a').css('margin-left', 'calc(100%/4)');
        $('.progressbar').removeClass('portland-glass');
    }else{
        $('.progressbar').removeClass('mra-progress-bar');
        $('.progressbar a[data-step="about-home-screen"], .progressbar a[data-step="estimate-screen"]').parent().hide();
        $('.progressbar a[data-step="about-service-needs-screen"], .progressbar a[data-step="vehicle-information-screen"]').parent().hide();
        $('.progressbar a[data-step="service-details-screen"]').parent().show();
        $('.progressbar a[data-step="calendar-screen"]').parent().show();
        $('.progressbar a[data-step="contact-information-screen"]').parent().removeClass('isLeadContact');
        $('.progressbar li').css('width', 'calc(100%/5)');
        $('.progressbar li:nth-child(4) a').css('margin-left', 'calc(100%/5)');
        $('.progressbar li:last-child a').css('margin-left', 'calc((100%/5) * -1)');
        $('.progressbar').removeClass('lead-flow'); 
        $('.progressbar').removeClass('portland-glass');    
    }
    var activepane = $('.wam-scheduler .tab-content .tab-pane.active').attr('id'); 
    setProgressBar(activepane);        
    $('.progressbar').children().removeClass('active');
    $('.progressbar').children().addClass('disabled');
    $('.progressbar').children().find('a').removeClass('active');
    $('.progressbar  a[data-step="' + activepane + '"]').addClass('active');
    $('.progressbar  a[data-step="' + activepane + '"]').parent().removeClass('disabled');
    $('.progressbar  a[data-step="' + activepane + '"]').parent().addClass('active');
}